(() => {
  if (window.__zsCartPageReady) return;
  window.__zsCartPageReady = true;

  const root = window.Shopify?.routes?.root || '/';

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-zs-cart-discount]');
    if (!form) return;
    event.preventDefault();

    const input = form.querySelector('input');
    const error = form.querySelector('[data-zs-discount-error]');
    const code = input?.value.trim();
    if (!code) {
      if (error) error.hidden = false;
      input?.focus();
      return;
    }

    if (error) error.hidden = true;
    window.location.assign(`${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(`${root}cart`)}`);
  });

  // "Guardar para después": reutiliza el mismo localStorage ('zs-favoritos', array de
  // handles) que el corazón de favoritos de las tarjetas de producto (zs-product-card.js)
  // y el cajón de favoritos del header, para que el producto reaparezca ahí. Después
  // saca la línea del carrito con la misma URL que usa el botón de eliminar normal.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-zs-save-for-later]');
    if (!button) return;
    event.preventDefault();

    const handle = button.dataset.productHandle;
    const removeUrl = button.dataset.removeUrl;
    if (!handle || !removeUrl) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const favorites = JSON.parse(window.localStorage.getItem('zs-favoritos') || '[]');
      if (!favorites.includes(handle)) favorites.push(handle);
      window.localStorage.setItem('zs-favoritos', JSON.stringify(favorites));
      document.dispatchEvent(new CustomEvent('zs:favorites:changed', { detail: { handles: favorites } }));
    } catch (error) {
      // Si localStorage falla (modo privado, cuota llena, etc.) igual sacamos el
      // producto del carrito: es mejor que "guardar para después" solo elimine
      // a que el botón quede sin hacer nada.
    }

    window.location.assign(removeUrl);
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-zs-clear-cart]');
    if (!button) return;

    const confirmation = button.dataset.confirmation;
    if (confirmation && !window.confirm(confirmation)) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${root}cart/clear.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      });
      if (!response.ok) throw new Error('No se pudo vaciar el carrito');
      window.location.reload();
    } catch (error) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      document.getElementById('cart-errors')?.replaceChildren(document.createTextNode(error.message));
    }
  });
})();
